import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { VennPlot } from "../components/VennPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.venn_tool_name()}
        toolPath="/venn-diagram"
      />
      <SciHeader title={m.venn_h1()} intro={m.venn_intro()} />

      <VennPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.venn_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.venn_ex1(), m.venn_ex2(), m.venn_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.venn_faq_q1(), a: m.venn_faq_a1() },
          { q: m.venn_faq_q2(), a: m.venn_faq_a2() },
          { q: m.venn_faq_q3(), a: m.venn_faq_a3() },
          { q: m.venn_faq_q4(), a: m.venn_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
